import * as THREE from 'three'
import { useState, useEffect, useRef, useReducer, useMemo } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { useGLTF, Environment, Lightformer, MeshReflectorMaterial  } from '@react-three/drei'
import { BallCollider, Physics, RigidBody  } from '@react-three/rapier'
import { easing } from 'maath'
import { Text3D } from '@react-three/drei'

import SplitTextHover from './SplitTextHover'
import HeroSection from './HorizontalScroll'
import AnimatedPointer from './AnimatedPointer'
import Sidebar from './Sidebar'
import Footer from './Footer'
import InfiniteSlider from './InfiniteSlider'
// import ContactForm from './ContactForm'
import LoaderPage from './LoaderPage'
import AboutMe from './AboutMe'


const accents = ['#D4BEE4', '#AD98E0', '#b98df7'];
const shuffle = (accent = 0) => [
{ color: '#444', roughness: 0.2, metalness: 0.5 },  
{ color: '#444', roughness: 0.2, metalness: 0.5 }, 
{ color: '#444', roughness: 0.2, metalness: 0.5 },
{ color: 'white', roughness: 0.05, metalness: 0.6 },  
{ color: accents[accent], roughness: 0.05, metalness: 0.6, accent: true}, 
{ color: accents[accent], roughness: 0.05, metalness: 0.6, accent: true},
{ color: accents[accent], roughness: 0.05, metalness: 0.6, accent: true},
{ color: accents[accent], roughness: 0.05, metalness: 0.6, accent: true},
];

export const App = () => (
<>
<div className="container" id='home'>
<Scene className="Scene-canv" />

    <SplitTextHover />   

    {/* <div  className='logo-container'>
      <img src='/images/limitless.jpg' />
      </div>      */}

  <div className="sidebar-container">
    <Sidebar />
  </div>
  {/* <div className='personal-picture'>
      <img src='/images/Avatar.png' alt='Personal-Photo' className='Avatar-class'/>
  </div> */}
  <div className='h1-header-popup'>
      <h1>
          NO <span>LIMITS</span>  TO YOUR <span> IDEAS</span>
      </h1>
  </div>
  <div className='animatedPointer'>
    <AnimatedPointer />
  </div>
</div>

    <div id='Projects'>
      <HeroSection />
    </div>
    

    <InfiniteSlider />

    <AboutMe />

    <div className='Footer' id='Footer'>

      {/* <ContactForm /> */}

      <div className='footer-position'>
        <Footer />
      </div>
      
    </div>
  </>
)




function Scene(props) {
const [isLoading, setIsLoading] = useState(true);

useEffect(() => {
// Ensure the page always starts at the top
window.scrollTo(0, 0);

// Simulate the loading process
const timer = setTimeout(() => {
setIsLoading(false); // End the loading state
}, 2000); // Adjust the duration as needed

return () => clearTimeout(timer); // Clean up the timer
}, [isLoading]); // Depend on isLoading to reset state properly on reload

const [accent, click] = useReducer((state) => ++state % accents.length, 0)
const connectors = useMemo(() => shuffle(accent), [accent])
return (
<>
{isLoading ? (
            <LoaderPage /> 
        ) : (
<Canvas onClick={click} shadows dpr={[1, 1.5]} gl={{ antialias: false }} camera={{ position: [0, 0, 15], fov: 17.5, near: 1, far: 40 }} {...props}>
  {/* <OrbitControls /> */}
  <ambientLight intensity={0.4} />
  <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} intensity={1} castShadow />
  <Physics gravity={[0, 0, -3]}>
          {/* <Debug /> */}
  <ResponsiveText />
    <Pointer />
    {connectors.map((props, i) => <Connector key={i} {...props} />)}
  </Physics>
  <Environment resolution={256}>
    <group rotation={[-Math.PI / 3, 0, 1]}>
      <Lightformer form="circle" intensity={8} rotation-x={Math.PI / 2} position={[0, 5, -9]} scale={2} />
      <Lightformer form="circle" intensity={4} rotation-y={Math.PI / 2} position={[-5, 1, -1]} scale={2} />
      <Lightformer form="circle" intensity={4} rotation-y={Math.PI / 2} position={[-5, -1, -1]} scale={2} />
      <Lightformer form="circle" intensity={4} rotation-y={-Math.PI / 2} position={[10, 1, 0]} scale={8} />
    </group>
  </Environment>
</Canvas>

)}
</>
)
}

function Connector({ position, children, vec = new THREE.Vector3(), scale, r = THREE.MathUtils.randFloatSpread, accent, ...props }) {
const api = useRef();
const pos = useMemo(() => position || [r(10), r(10), r(10)], []);

useFrame((_, delta) => {
delta = Math.min(0.1, delta);
const impulseStrength = 0.01; 
api.current?.applyImpulse(
  vec
    .copy(api.current.translation())
    .negate()
    .multiplyScalar(impulseStrength) 
);
});

return (
<RigidBody
  linearDamping={1} 
  angularDamping={1} 
  friction={0.05}
  position={pos}
  ref={api}
  colliders="hull"
>
   {children ? children : <Model {...props} />} 
  {/*{children ? children : <Model2 {...props} />}*/}
  {accent && <pointLight intensity={4} distance={2.5} color={props.color} />}
</RigidBody>
);
}

function Pointer({ vec = new THREE.Vector3() }) {
const ref = useRef()
useFrame(({ mouse, viewport }) => {
ref.current?.setNextKinematicTranslation(vec.set((mouse.x * viewport.width) / 2, (mouse.y * viewport.height) / 2, 0))
})
return (
<RigidBody position={[0, 0, -2]} type="kinematicPosition" colliders="ball" ref={ref}>
  <BallCollider args={[1]} position={[0,0,-0.4]} />
</RigidBody>
)
}


//Limitless Model

function Model({ children, color = 'white', roughness = 0, ...props }) {
const ref = useRef()
const { nodes } = useGLTF('/model/LimitlessIcon5.glb')
useFrame((_, delta) => {
easing.dampC(ref.current.material.color, color, 0.2, delta)
})
return (
<group {...props} dispose={null} rotation={[0, Math.PI / 2, 0]}>
  <mesh ref={ref} geometry={nodes.SurfTorus.geometry} material={nodes.SurfTorus.material} position={[0, 0, -0.46]} rotation={[0, 0, -Math.PI / 2]} scale={0.5}>
  <meshStandardMaterial metalness={0.2} roughness={0}/>
  </mesh>
  <mesh ref={ref} geometry={nodes.SurfTorus001.geometry} material={nodes.SurfTorus001.material} position={[0, 0, 0.46]} rotation={[0, 0, -Math.PI / 2]} scale={0.5}>
  <meshStandardMaterial metalness={0.2} roughness={0}  />
  </mesh>
</group>
)
};

// function Model2({ color = 'white', roughness = 0, scale = 0.5, ...props }) {
//   const ref = useRef();
//   useFrame((state, delta) => {
//     easing.dampC(ref.current.material.color, color, 0.2, delta)
//   })
//   return (
//     <Physics position={[0,0,0]}>
//     <mesh ref={ref} castShadow receiveShadow scale={scale} {...props}>
//       <torusGeometry args={[1, 0.4, 16, 100]} />
//       <meshStandardMaterial color={color} roughness={roughness} metalness={0.2} />
//     </mesh>
//     </Physics>
//   );
// }




function ResponsiveText({ text = "Limitless" }) {
const [fontSize, setFontSize] = useState(getResponsiveFontSize());
const [position, setPosition] = useState(getResponsivePosition());

function getResponsiveFontSize() {
const width = window.innerWidth;
if (width <= 380) return 0.2;
if (width <= 430) return 0.3;
if (width <= 570) return 0.4;
return 0.6;
}

function getResponsivePosition() {
const width = window.innerWidth;
if (width <= 380) return [-0.50, 0.2, -0.5];
if (width <= 430) return [-0.78, 0, -0.5];
if (width <= 570) return [-1.05, 0, -0.5];
return [-1.58, 0, -0.5];
}

useEffect(() => {
function handleResize() {
  setFontSize(getResponsiveFontSize());
  setPosition(getResponsivePosition());
}
window.addEventListener("resize", handleResize);
return () => window.removeEventListener("resize", handleResize);
}, []);
// const colliderSize = [3.3, 0.7, 0.2];
return (
<group>

  
  <RigidBody position={position} type="fixed" colliders="hull">

  {/* Text */}
  <Text3D
    font="/fonts/helvetiker_regular.typeface.json"
    size={fontSize}
    height={0.1}
    curveSegments={32}
    bevelEnabled
    bevelThickness={0.05}
    bevelSize={0.025}
  >
    {text}
    <MeshReflectorMaterial
    resolution={1024}
      // color={"#ffffff"}
      // metalness={0.4}
      // roughness={0.3}
      // emissive="#ffffff"
      // emissiveIntensity={0.1}
    />
  </Text3D>
</RigidBody>
</group>

);
}
